import { formatLongDate } from "./dateUtils";
import type { DriverAvailability, GroupedAvailability } from "@/types/availability";

/** GET /me/availabilities devolvió distintas formas a lo largo del tiempo; se toleran todas. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const readAvailabilitiesResponse = (response: any): DriverAvailability[] => {
  if (Array.isArray(response?.data)) return response.data;
  if (Array.isArray(response?.data?.data)) return response.data.data;
  if (Array.isArray(response?.data?.availabilities)) return response.data.availabilities;
  return [];
};

/** Agrupa por (fecha, operación); orden: fecha, después nombre de operación. */
export const groupAvailabilitiesByDateAndOperation = (
  availabilities: DriverAvailability[],
  operationNames: Map<number, string>
): GroupedAvailability[] => {
  const grouped = availabilities.reduce((acc, availability) => {
    const dateKey = availability.date.split("T")[0]; // YYYY-MM-DD
    const operationId = availability.svc.operationId;
    const key = `${dateKey}|${operationId}`;

    if (!acc[key]) {
      acc[key] = {
        date: dateKey,
        formattedDate: formatLongDate(availability.date),
        operationId,
        operationName: operationNames.get(operationId) ?? `Operación ${operationId}`,
        availabilities: [],
        shifts: [],
        svcs: [],
        vehicles: [],
      };
    }

    acc[key].availabilities.push(availability);

    if (!acc[key].shifts.includes(availability.shift)) {
      acc[key].shifts.push(availability.shift);
    }

    const svcExists = acc[key].svcs.some((svc) => svc.id === availability.svc.id);
    if (!svcExists) {
      acc[key].svcs.push(availability.svc);
    }

    if (availability.vehicle) {
      const vehicleExists = acc[key].vehicles.some(
        (vehicle) => vehicle.id === availability.vehicle!.id
      );
      if (!vehicleExists) {
        acc[key].vehicles.push(availability.vehicle);
      }
    }

    return acc;
  }, {} as Record<string, GroupedAvailability>);

  return Object.values(grouped).sort(
    (a, b) => a.date.localeCompare(b.date) || a.operationName.localeCompare(b.operationName, "es")
  );
};
